import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Lv = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { fill: "#E6E6E6", d: "M21,5.091H0v3.818h21V5.091z" }),
    React.createElement("path", { fill: "#861624", d: "M21,0H0v5.091h21V0z" }),
    React.createElement("path", { fill: "#861624", d: "M21,8.909H0V14h21V8.909z" })), 'Lv', { width: 21, height: 14, viewBox: '0 0 21 14' });
export default Lv;
